import {
	addSignature as addSignatureInStore,
	updateSingleSignature,
	removeSignature,
	addMeal as addMealInStore,
	updateSingleMeal,
	removeMeal as removeMealInStore
} from "./store/settings-actions";
import {
	MessageSignature,
	addMessageSignature,
	patchMessageSignature,
	deleteMessageSignature
} from "../api/settings";
import { store } from "../store";
import { setSnackbarMessage } from "./store/snackbar-actions";
import { Meal, addMeal as addMealViaApi, patchMeal, removeMeal } from '../api/meals';

export const addSignature = async (signature: MessageSignature) => {
	try {
		const res = await addMessageSignature(signature);
		store.dispatch(addSignatureInStore(res));
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage(
				"Signatur konnte nicht gespeichert werden!",
				"error"
			)
		);
	}
};

export const updateSignature = async (
	id: string,
	updateData: Partial<MessageSignature>
) => {
	try {
		const res = await patchMessageSignature(id, updateData);
		store.dispatch(updateSingleSignature(id, updateData));
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage(
				"Signatur konnte nicht aktualisiert werden!",
				"error"
			)
		);
	}
};

export const deleteSignature = async (id: string) => {
	try {
		await deleteMessageSignature(id);
		store.dispatch(removeSignature(id));
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage(
				"Signatur konnte nicht gelöscht werden!",
				"error"
			)
		);
	}
};

export const addMeal = async (meal: Meal) => {
	try {
		const res = await addMealViaApi(meal);
		store.dispatch(addMealInStore(res));
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage(
				"Speise konnte nicht gespeichert werden!",
				"error"
			)
		);
	}
};

export const updateMeal = async (
	id: string,
	updateData: Partial<Meal>
) => {
	try {
		const res = await patchMeal(id, updateData);
		store.dispatch(updateSingleMeal(id, updateData));
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage(
				"Speise konnte nicht aktualisiert werden!",
				"error"
			)
		);
	}
};

export const deleteMeal = async (id: string) => {
	try {
		await removeMeal(id);
		store.dispatch(removeMealInStore(id));
	} catch (e) {
		console.error(e);
		store.dispatch(
			setSnackbarMessage(
				"Speise konnte nicht gelöscht werden!",
				"error"
			)
		);
	}
};
